import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Twitter, Mail, Phone, MapPin } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";

const Footer = () => {
  const { lang } = useLanguage();
  const t = useT(lang);

  return (
    <footer className="mt-32 border-t border-goldSoft bg-[#080808] relative overflow-hidden">
      <div className="absolute right-0 top-0 opacity-10 select-none pointer-events-none">
        <span className="font-cn text-[200px] leading-none text-gold">詠</span>
      </div>
      <div className="container-wc py-16 grid grid-cols-1 md:grid-cols-4 gap-10 relative">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <span className="font-cn text-gold text-4xl">詠春</span>
            <span className="font-serif text-2xl">Wing Chun</span>
          </div>
          <p className="text-dim max-w-md">{t.footer.tagline}</p>
          <p className="text-dim max-w-md mt-3 text-sm">Sifu Νίκος Αγαθόπουλος</p>
        </div>

        <div>
          <h4 className="eyebrow mb-4">{t.footer.quick_links}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/sifu" data-testid="footer-sifu" className="text-dim hover:text-gold transition-colors">{t.nav.sifu}</Link></li>
            <li><Link to="/wing-chun" data-testid="footer-wingchun" className="text-dim hover:text-gold transition-colors">{t.nav.wingchun}</Link></li>
            <li><Link to="/book" data-testid="footer-book" className="text-dim hover:text-gold transition-colors">{t.nav.bookPage}</Link></li>
            <li><Link to="/reviews" data-testid="footer-reviews" className="text-dim hover:text-gold transition-colors">{t.nav.reviews}</Link></li>
            <li><Link to="/schedule" data-testid="footer-schedule" className="text-dim hover:text-gold transition-colors">{t.nav.schedule}</Link></li>
            <li><Link to="/blog" data-testid="footer-blog" className="text-dim hover:text-gold transition-colors">{t.nav.blog}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">{t.footer.follow}</h4>
          <div className="flex flex-col gap-2 text-sm">
            <a data-testid="footer-phone" href="tel:+306979631031" className="text-dim hover:text-gold flex items-center gap-2 transition-colors">
              <Phone size={14} /> +30 6979 631031
            </a>
            <a data-testid="footer-email" href="mailto:info@wingchun.gr" className="text-dim hover:text-gold flex items-center gap-2 transition-colors">
              <Mail size={14} /> info@wingchun.gr
            </a>
            <span className="text-dim flex items-center gap-2">
              <MapPin size={14} /> {t.contact.location}
            </span>
          </div>
          <div className="flex items-center gap-3 mt-5">
            <a href="https://www.facebook.com/www.wingchun.gr/" target="_blank" rel="noreferrer" data-testid="social-fb" className="text-dim hover:text-gold transition-colors"><Facebook size={18} /></a>
            <a href="https://www.instagram.com/wingchun_nikos_agathopoulos/" target="_blank" rel="noreferrer" data-testid="social-ig" className="text-dim hover:text-gold transition-colors"><Instagram size={18} /></a>
            <a href="https://twitter.com/nikaga" target="_blank" rel="noreferrer" data-testid="social-x" className="text-dim hover:text-gold transition-colors"><Twitter size={18} /></a>
            <a href="https://www.youtube.com/channel/UCRHsN15-XzsAPrA4ECpCPRg" target="_blank" rel="noreferrer" data-testid="social-yt" className="text-dim hover:text-gold transition-colors"><Youtube size={18} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-goldSoft">
        <div className="container-wc py-5 flex flex-col md:flex-row justify-between text-xs text-dim gap-2">
          <span>© {new Date().getFullYear()} wingchun.gr — {t.footer.rights}</span>
          <span className="font-cn text-gold">詠春拳</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
